// Données mockup des salons avec images professionnelles
export const mockupSalons = [
  {
    id: "salon_001",
    uid: "salon_001",
    salonName: "Coiffure Élégance",
    ownerName: "Marie Dubois",
    email: "coiffureelegance@example.com",
    phone: "01 42 36 78 90",
    address: "15 Rue de Rivoli",
    city: "Paris",
    region: "Île-de-France",
    category: "Salon de coiffure ou barbershop",
    description: "Salon de coiffure moderne au cœur de Paris, spécialisé dans les coupes tendances et les colorations créatives. Notre équipe de professionnels vous accueille dans un cadre chaleureux et contemporain.",
    photos: [
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    ],
    services: [
      { name: "Coupe femme", price: 45, duration: 60 },
      { name: "Coupe homme", price: 35, duration: 45 },
      { name: "Coloration", price: 80, duration: 120 },
      { name: "Mèches", price: 90, duration: 150 },
      { name: "Brushing", price: 25, duration: 30 },
      { name: "Soin capillaire", price: 35, duration: 45 }
    ],
    schedule: {
      monday: { open: '09:00', close: '18:00', closed: false },
      tuesday: { open: '09:00', close: '18:00', closed: false },
      wednesday: { open: '09:00', close: '18:00', closed: false },
      thursday: { open: '09:00', close: '19:00', closed: false },
      friday: { open: '09:00', close: '19:00', closed: false },
      saturday: { open: '09:00', close: '17:00', closed: false },
      sunday: { open: '10:00', close: '16:00', closed: true }
    },
    rating: 4.8,
    reviewCount: 127,
    featured: true,
    role: 'salon',
    isPublic: true,
    createdAt: new Date('2024-01-15'),
    subscription: {
      plan: 'premium',
      active: true
    }
  },
  {
    id: "salon_002",
    uid: "salon_002",
    salonName: "Barbershop Vintage",
    ownerName: "Antoine Martin",
    email: "barbershopvintage@example.com",
    phone: "04 91 55 23 67",
    address: "8 Cours Julien",
    city: "Marseille",
    region: "Provence-Alpes-Côte d'Azur",
    category: "Salon de coiffure ou barbershop",
    description: "Barbershop authentique dans l'esprit vintage américain. Spécialistes de la taille de barbe et des coupes masculines classiques et modernes.",
    photos: [
      "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1622287162716-f311baa1a2b8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    ],
    services: [
      { name: "Coupe homme", price: 30, duration: 45 },
      { name: "Taille de barbe", price: 20, duration: 30 },
      { name: "Coupe + Barbe", price: 45, duration: 60 },
      { name: "Rasage traditionnel", price: 25, duration: 30 },
      { name: "Soin barbe", price: 15, duration: 20 }
    ],
    schedule: {
      monday: { open: '08:00', close: '19:00', closed: false },
      tuesday: { open: '08:00', close: '19:00', closed: false },
      wednesday: { open: '08:00', close: '19:00', closed: false },
      thursday: { open: '08:00', close: '20:00', closed: false },
      friday: { open: '08:00', close: '20:00', closed: false },
      saturday: { open: '08:00', close: '18:00', closed: false },
      sunday: { open: '10:00', close: '17:00', closed: false }
    },
    rating: 4.9,
    reviewCount: 89,
    featured: true,
    role: 'salon',
    isPublic: true,
    createdAt: new Date('2024-02-20'),
    subscription: {
      plan: 'premium',
      active: true
    }
  },
  {
    id: "salon_003",
    uid: "salon_003",
    salonName: "Belle Époque Institut",
    ownerName: "Sophie Laurent",
    email: "belleepoqueinstitut@example.com",
    phone: "03 20 45 67 89",
    address: "22 Rue Nationale",
    city: "Lille",
    region: "Hauts-de-France",
    category: "Institut de beauté ou bar à ongles",
    description: "Institut de beauté complet proposant soins du visage, manucure, pédicure et épilation. Un havre de paix pour prendre soin de vous.",
    photos: [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    ],
    services: [
      { name: "Soin visage hydratant", price: 65, duration: 75 },
      { name: "Manucure classique", price: 25, duration: 45 },
      { name: "Pédicure", price: 35, duration: 60 },
      { name: "Épilation jambes", price: 40, duration: 45 },
      { name: "Épilation sourcils", price: 15, duration: 15 },
      { name: "Pose vernis semi-permanent", price: 35, duration: 60 }
    ],
    schedule: {
      monday: { open: '09:00', close: '18:00', closed: false },
      tuesday: { open: '09:00', close: '18:00', closed: false },
      wednesday: { open: '09:00', close: '18:00', closed: false },
      thursday: { open: '09:00', close: '19:00', closed: false },
      friday: { open: '09:00', close: '19:00', closed: false },
      saturday: { open: '09:00', close: '17:00', closed: false },
      sunday: { open: '10:00', close: '16:00', closed: true }
    },
    rating: 4.7,
    reviewCount: 156,
    featured: false,
    role: 'salon',
    isPublic: true,
    createdAt: new Date('2024-01-10'),
    subscription: {
      plan: 'standard',
      active: true
    }
  },
  {
    id: "salon_004",
    uid: "salon_004",
    salonName: "Zen Spa Wellness",
    ownerName: "Isabelle Moreau",
    email: "zenspawellness@example.com",
    phone: "05 56 78 90 12",
    address: "45 Cours de l'Intendance",
    city: "Bordeaux",
    region: "Nouvelle-Aquitaine",
    category: "Spa ou centre de bien-être",
    description: "Centre de bien-être dédié à la relaxation et au ressourcement. Massages thérapeutiques, soins du corps et rituels de détente dans un cadre zen.",
    photos: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    ],
    services: [
      { name: "Massage relaxant", price: 70, duration: 60 },
      { name: "Massage deep tissue", price: 85, duration: 75 },
      { name: "Soin du dos", price: 60, duration: 45 },
      { name: "Gommage corps", price: 55, duration: 45 },
      { name: "Enveloppement détox", price: 75, duration: 60 },
      { name: "Massage pierres chaudes", price: 90, duration: 90 }
    ],
    schedule: {
      monday: { open: '10:00', close: '19:00', closed: false },
      tuesday: { open: '10:00', close: '19:00', closed: false },
      wednesday: { open: '10:00', close: '19:00', closed: false },
      thursday: { open: '10:00', close: '20:00', closed: false },
      friday: { open: '10:00', close: '20:00', closed: false },
      saturday: { open: '09:00', close: '18:00', closed: false },
      sunday: { open: '10:00', close: '17:00', closed: false }
    },
    rating: 4.9,
    reviewCount: 203,
    featured: true,
    role: 'salon',
    isPublic: true,
    createdAt: new Date('2024-03-05'),
    subscription: {
      plan: 'premium',
      active: true
    }
  },
  {
    id: "salon_005",
    uid: "salon_005",
    salonName: "Studio Coiffure Moderne",
    ownerName: "Julien Petit",
    email: "studiocoiffuremoderne@example.com",
    phone: "04 72 33 44 55",
    address: "12 Rue de la République",
    city: "Lyon",
    region: "Auvergne-Rhône-Alpes",
    category: "Salon de coiffure ou barbershop",
    description: "Studio de coiffure avant-gardiste proposant des coupes créatives et des techniques de coloration innovantes. Ambiance moderne et musicale.",
    photos: [
      "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1595475038665-8de2a4b72bb8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
    ],
    services: [
      { name: "Coupe créative femme", price: 55, duration: 75 },
      { name: "Coupe homme", price: 40, duration: 50 },
      { name: "Coloration fantaisie", price: 120, duration: 180 },
      { name: "Balayage", price: 95, duration: 150 },
      { name: "Lissage brésilien", price: 150, duration: 180 },
      { name: "Extensions", price: 200, duration: 240 }
    ],
    schedule: {
      monday: { open: '10:00', close: '19:00', closed: false },
      tuesday: { open: '10:00', close: '19:00', closed: false },
      wednesday: { open: '10:00', close: '19:00', closed: false },
      thursday: { open: '10:00', close: '20:00', closed: false },
      friday: { open: '10:00', close: '20:00', closed: false },
      saturday: { open: '09:00', close: '18:00', closed: false },
      sunday: { open: '11:00', close: '17:00', closed: true }
    },
    rating: 4.6,
    reviewCount: 94,
    featured: false,
    role: 'salon',
    isPublic: true,
    createdAt: new Date('2024-02-14'),
    subscription: {
      plan: 'standard',
      active: true
    }
  }
];

// Fonction pour obtenir les salons en vedette
export const getFeaturedSalons = () => {
  return mockupSalons.filter(salon => salon.featured);
};

// Fonction pour obtenir tous les salons
export const getAllSalons = () => {
  return mockupSalons;
};

// Fonction pour obtenir un salon par ID
export const getSalonById = (id) => {
  return mockupSalons.find(salon => salon.id === id || salon.uid === id);
};

// Fonction pour obtenir les salons par ville
export const getSalonsByCity = (city) => {
  return mockupSalons.filter(salon => 
    salon.city.toLowerCase().includes(city.toLowerCase())
  );
};

// Fonction pour obtenir les salons par catégorie
export const getSalonsByCategory = (category) => {
  return mockupSalons.filter(salon => 
    salon.category.toLowerCase().includes(category.toLowerCase())
  );
};

// Fonction pour rechercher des salons
export const searchSalons = (query) => {
  const searchTerm = query.toLowerCase();
  return mockupSalons.filter(salon => 
    salon.salonName.toLowerCase().includes(searchTerm) ||
    salon.city.toLowerCase().includes(searchTerm) ||
    salon.category.toLowerCase().includes(searchTerm) ||
    salon.description.toLowerCase().includes(searchTerm)
  );
};

export default mockupSalons;